<template>

<div class="main terms-of-use">
	<div class="list-view no-sub-header">

    	<div class="filters">
			<div :class="['filter-list-button-large', whichFeature == 'paperless'? 'active' : '']" @click="toggleSettings('paperless')">
				<div class="label">Paperless 4473</div>
				<div class="note">Generate an ATF Notification Letter</div>
			</div>
			<div :class="['filter-list-button-large', whichFeature == 'signonscreen'? 'active' : '']" @click="toggleSettings('signonscreen')">
				<div class="label">Sign On Screen</div>
				<div class="note">Enable customer and employee sign on screen</div>
			</div>
			<div :class="['filter-list-button-large', whichFeature == 'transactionrecords'? 'active' : '']" @click="toggleSettings('transactionrecords')">
				<div class="label">Transaction Records</div>
				<div class="note">Enable firearms transaction records</div>
			</div>
        </div>

        <div v-if="whichFeature == 'paperless'" class="detail">
			<h1>Paperless 4473</h1>
			<div class="two-columns" style="grid-column-gap: 3em;">
				<div>
					<p>On August 17, 2022, the ATF issued Rule 2022-01 which authorizes paperless storage of 4473s without the need for a specific variance.</p>
					<p>Your Flight Deck Log Book system has been reviewed by the ATF and meets the technical requirements of this ruling.</p>
					<p>But Rule 2022-01 includes a requirement that <b>"Licensees must provide written notification to their local ATF Intrustry Operations Area Office 60 days prior to implementing an electronic Form 4473 retention system."</b></p>
					<p>To generate your notification letter, simply enter your ATF area office info, the name of the responsible person at your location, and hit Generate ATF Letter. You will then be able to <b>print</b> and <b>sign</b> the letter before mailing it to the ATF.</p>
					<p>After you generate your letter, click the <b>Enable Paperless</b> button on the left.</p>
					<p>&nbsp;</p>
					<p><b>IMPORTANT!</b><br>You <b>must</b> continue to print your 4473s for 60 days from the date you submit your ATF notification letter.</p>
					<p><a href="https://s3.us-east-2.amazonaws.com/media.connecteddatasolutions.com/downloads/2022-1-electronic_storage_of_forms_4473_0.pdf" target="_blank">Download a copy of ATF Ruling 2022-01 here...</a></p>
				</div>
				<div>
					<h2>Generate a notification letter</h2>
					<p v-if="paperlessData.date">You last generated this letter on {{ paperlessData.date }}.</p>
					<label>Your ATF Field Office</label>
					<input type="text" v-model="paperlessData.field_office" />
					<label>Field Office Address</label>
					<input type="text" v-model="paperlessData.field_office_address" />
					<label>Field Office City</label>
					<input type="text" v-model="paperlessData.field_office_city" />
					<div class="two-columns">
						<label>Field Office State</label>
						<label>Field Office Zip Code</label>
						<input type="text" v-model="paperlessData.field_office_state" />
						<input type="text" v-model="paperlessData.field_office_zip_code" />
					</div>
					<label>Name of Responsible Person (your name)</label>
					<input type="text" v-model="paperlessData.responsible_person" />
					<div class="controls">
						<div :class="['button', canGeneratePaperlessPDF() && !loading ? 'action' : 'disabled']" @click="generateEnablePaperlessPDF()">Generate ATF Letter</div>
						<i v-if="loading" class="fa fa-spinner fa-spin" style="margin: 0 0 0 1em; "/>
					</div>
					<div class="note">{{ letterGenerated ? 'Be sure' : 'You will be able' }} to print and sign your letter<br>so you can mail it to your ATF Field Office.</div>

            		<div :class="['button', letterGenerated && !paperlessEnabled ? 'action' : 'disabled']" @click="enablePaperless()">Enable Paperless</div>
            		<div class="message">{{ message }}</div>

				</div>
			</div>
		</div>

		<div v-if="whichFeature == 'signonscreen'" class="detail">
			<h1>4473 Sign on Screen</h1>
			<div class="two-one-columns" style="grid-column-gap: 3em;">
				<div ref="sign_on_screen_content">
					<h3 style="margin: 0 0 1em 0;">FEATURE REQUEST AND LIABILITY RELEASE</h3>
					<p>As an AUTHORIZED REPRESENTATIVE of <b>{{ signOnScreenData.company_name }}</b> I hereby request permission to use the Connected Data Solutions FFL Log Book "Sign On Screen" feature in my day-to-day operations involving both customer and employee signatures for the electronic ATF Form 4473.</p>
					<p>I HEREBY ASSUME ALL OF THE RISKS OF USING THIS FEATURE, including by way of example and not limitation, any warnings or fines imposed by an officer or agent of the ATF for using the "Sign On Screen" FEATURE instead of using an external signature device.</p>
					<p>In consideration of this request and subsequent permission to use this feature, I hereby take action for myself, the company named above, any of that company's employees, managers, directors and owners, and assigns as follows:</p>
					<p>I WAIVE, RELEASE, AND DISCHARGE from any and all liability, including but not limited to, liability arising from the negligence or fault of the entities or persons released, for any compliance issues noted by the ATF or any other agency responsible for FFL compliance, THE FOLLOWING ENTITIES OR PERSONS: Connected Data Solutions and/or their directors, officers, employees, volunteers, representatives, and agents; INDEMNIFY, HOLD HARMLESS, AND PROMISE NOT TO SUE the entities or persons mentioned in this paragraph from any and all liabilities or claims made as a result of using this FEATURE, whether caused by the negligence of releasee or otherwise.</p>
					<p>I acknowledge that Connected Data Solutions and their directors, officers, volunteers, representatives, and agents are NOT responsible for the errors, omissions, acts, or failures to act of any party or entity responsible for the development and release of this FEATURE.</p>
					<p>This Feature Request and Release of Liability Waiver Form shall be construed broadly to provide a release and waiver to the maximum extent permissible under applicable law.</p>
					<p>I CERTIFY THAT I HAVE READ THIS DOCUMENT AND I FULLY UNDERSTAND ITS CONTENT. I AM AWARE THAT THIS IS A FEATURE REQUEST AND RELEASE OF LIABILITY AND A CONTRACT AND I SIGN IT OF MY OWN FREE WILL.</p>
					<div style="font-size: 1.25em; width: 24em; border-bottom: 1px solid #333; padding: 1em 0 0.25em 0;">{{ signOnScreenData.company_name }}</div>Company Name
					<div style="font-size: 1.25em; width: 24em; border-bottom: 1px solid #333; padding: 1em 0 0.25em 0;">
						<span v-if="signOnScreenData.responsible_person">{{ signOnScreenData.responsible_person }}</span>
						<input v-else type="text" v-model="signOnScreenResponsiblePerson" />
					</div>Printed Name of Authorized Representative
					<div style="font-size: 1.25em; width: 24em; border-bottom: 1px solid #333; padding: 1em 0 0.25em 0;">
						<img v-if="signOnScreenData.signature" :src="signOnScreenData.signature" style="width: auto;" />
						<div v-else>
							<div style="float: right; font-size: 0.75em;">
								<div class="button action" style="display: block; width: 7em;" @click="saveSignature()">Accept</div><br>
								<div class="button neutral" style="display: block; width: 7em;" @click="clearCanvas()">Clear</div>
							</div>
							<canvas id="signature_pad" width="360" height="130"></canvas>
						</div>
					</div>Signature of Authorized Representative
					<div style="font-size: 1.25em; width: 22em; border-bottom: 1px solid #333; padding: 1em 0 0.25em 0;">{{ signOnScreenData.date }}</div>Signed Date
				</div>
				<div>
					<h2>Enable Sign on Screen</h2>
					<p>Flight Deck 4473s support a "sign on screen" feature which allows your customers and employees to record a signature using a mouse or touch screen.</p>
					<div v-if="signOnScreenEnabled">
						<p>Sign on screen is enabled. You can print a copy of your Feature Request and Liability Release for your records.</p>
						<div class="controls">
							<div :class="['button', saving ? 'disabled' : 'action']" @click="generateSignOnScreenPDF()">Print</div>
							<i v-if="saving" class="fa fa-spinner fa-spin" style="margin: 0 0 0 1em; "/>
						</div>
						<div class="message">{{ message }}</div>
					</div>
					<div v-else>
						<p>To enable this feature, enter the name of an Authorized Representative and sign the Feature Request and Liability Release displayed.</p>
						<div class="controls">
							<div :class="['button', canEnableSignOnScreen() && !saving ? 'action' : 'disabled']" @click="enableSignOnScreen()">Enable Sign On Screen</div>
							<i v-if="saving" class="fa fa-spinner fa-spin" style="margin: 0 0 0 1em; "/>
						</div>
            			<div class="message">{{ message }}</div>
					</div>
				</div>
			</div>
		</div>

        <div v-if="whichFeature == 'transactionrecords'" class="detail">
			<h1>Firearms Transaction Records</h1>
			<div class="two-columns" style="grid-column-gap: 3em;">
				<div>
					<p>Some states have specific requirements for firearms transaction records.</p>
					<p>With this option enabled, the following programs will include additional fields specifically for firearms transaction records:</p>
					<ul style="margin: 1em 2em;">
						<li>Inventory -> Receive Inventory</li>
						<li>Logbooks -> Receive Firearms</li>
						<li>Log Books -> Dispose Firearms</li>
					</ul>
					<p>Records created with these additional fields will be saved to a special Firearms Transaction Records list that can be accessed under the Logbooks -> Transaction Records program.</p>
				</div>
				<div>
					<h2>{{ firearmsTransactionInfo ? 'Disable' : 'Enable' }} Firearms Transaction Records</h2>
					<p v-if="firearmsTransactionInfo">
						Firearms transaction records are currently enabled. If you disable this feature, the additional fields will no longer be available in the relevant programs and no new records will be added to the Firearms Transaction Records list.
					</p>
					<p v-else>
						Firearms transaction records are currently disabled.
					</p>
            		<div class="button action" @click="enableTransactionRecords()">{{ firearmsTransactionInfo ? 'Disable' : 'Enable' }} Transaction Records</div>
            		<div class="message">{{ message }}</div>
				</div>
			</div>
		</div>

    </div>
	
	<help-popup :helpLink="{379:'Enable Paperless 4473s'}" :tours="false"></help-popup>

</div>

</template>

<script>
import SignaturePad from 'signature_pad'
SignaturePad.prototype.removeBlanks = function () {
	var imgWidth = this._ctx.canvas.width;
	var imgHeight = this._ctx.canvas.height;
	var imageData = this._ctx.getImageData(0, 0, imgWidth, imgHeight),
	data = imageData.data,
	getAlpha = function(x, y) {
		return data[(imgWidth*y + x) * 4 + 3]
	},
	scanY = function (fromTop) {
		var offset = fromTop ? 1 : -1;
		// loop through each row
		for(var y = fromTop ? 0 : imgHeight - 1; fromTop ? (y < imgHeight) : (y > -1); y += offset) {
			// loop through each column
			for(var x = 0; x < imgWidth; x++) {
				if (getAlpha(x, y)) {
					return y;
				}
			}
		}
		return null; // all image is white
	},
	scanX = function (fromLeft) {
		var offset = fromLeft? 1 : -1;
		// loop through each column
		for(var x = fromLeft ? 0 : imgWidth - 1; fromLeft ? (x < imgWidth) : (x > -1); x += offset) {
			// loop through each row
			for(var y = 0; y < imgHeight; y++) {
				if (getAlpha(x, y)) {
					return x;
				}
			}
		}
		return null; // all image is white
	};
	var cropTop = scanY(true),
	cropBottom = scanY(false),
	cropLeft = scanX(true),
	cropRight = scanX(false);
	var relevantData = this._ctx.getImageData(cropLeft, cropTop, cropRight-cropLeft, cropBottom-cropTop);
	this.canvas.width = cropRight-cropLeft;
	this.canvas.height = cropBottom-cropTop;
	this._ctx.clearRect(0, 0, cropRight-cropLeft, cropBottom-cropTop);
	this._ctx.putImageData(relevantData, 0, 0);
}
import HelpPopup from '@/components/HelpPopup.vue'

export default {
    name: 'enable-feature',
	components: {
		'help-popup': HelpPopup
    },
    data() {
        return {
            loading: false,
			saving: false,
            message: '',
            content: '',
			whichFeature: '',
			paperlessData: {
				field_office: '',
				field_office_address: '',
				field_office_city: '',
				field_office_state: '',
				field_office_zip_code: '',
				responsible_person: ''
			},
			letterGenerated: false,
			paperlessEnabled: false,
			signOnScreenData: {
				date: '',
				company_name: '',
				responsible_person: '',
				signature: ''
			},
			signOnScreenResponsiblePerson: '',
			signaturePad: null,
			signOnScreenEnabled: false,
			firearmsTransactionInfo: false
        }
    },
    created() {
		this.toggleSettings(Object.keys(this.$route.query)[0])
    },
    methods: {
		toggleSettings(which) {
			if (which != this.whichFeature) {
				this.whichFeature = which
				this.message = '';
				if (this.whichFeature == 'paperless') {
					this.getItemEnablePaperless()
				}
				if (this.whichFeature == 'signonscreen') {
					this.getItemEnableSignOnScreen()
 				}
				if (this.whichFeature == 'transactionrecords') {
					this.getEnableTransactionRecords()
 				}
			}
		},
		getItemEnablePaperless() {
    		this.apiCall({ destination: 'get_item_enable_paperless' }).then(obj => {
				this.paperlessEnabled = obj.electronic_storage_enabled
				if (this.paperlessEnabled) {
					this.message = 'Paperless is already enabled!'
				}
				if (obj.paperless_pdf) {
					this.paperlessData = JSON.parse(obj.paperless_pdf)
					this.letterGenerated = true;
				}
    		})
		},
		canGeneratePaperlessPDF() {
			for (const [key, value] of Object.entries(this.paperlessData)) {
				if (!value) {
					return false
				}
			}
			return true
		},
    	generateEnablePaperlessPDF() {
			if (this.loading) { return }
			if (!this.canGeneratePaperlessPDF()) { return }
			this.loading = true
			let postData = this.$copy(this.paperlessData) // copy the object so API doesn't add elements to the original
    		this.apiCall({ destination: 'generate_enable_paperless_pdf', data: postData }).then(obj => {
                this.loading = false
    			if (obj.status == 'success') {
					window.open(obj.pdf_url)
					this.letterGenerated = true
    			}
    		})
    	},
        enablePaperless() {
			if (this.saving || !this.letterGenerated) {
				return
			}
            this.message = ''
			this.saving = true
    		this.apiCall({ destination: 'enable_paperless_4473s' }).then(obj => {
                this.saving = false
                this.message = obj.message
				if (obj.status == 'success') {
					this.paperlessEnabled = true
				}
    		})
        },
		getItemEnableSignOnScreen() {
    		this.apiCall({ destination: 'get_item_enable_signonscreen' }).then(obj => {
				this.signOnScreenEnabled = obj.signonscreen_enabled
				if (obj.signonscreen_pdf) {
					this.signOnScreenData = JSON.parse(obj.signonscreen_pdf)
					this.message = 'Sign on screen already enabled!'
				} else {
					this.signOnScreenData.company_name = obj.company_name
					this.signOnScreenData.date = this.$moment().format('MM/DD/YYYY')
					setTimeout(() => {
						this.initializeSignaturePad()
					}, 500)
				}
    		})
		},
		initializeSignaturePad() {
			let canvas = document.getElementById("signature_pad")
			this.signaturePad = new SignaturePad(canvas, { minWidth: 2, maxWidth: 2 })
		},
		saveSignature() {
			this.signaturePad.removeBlanks()
			this.signOnScreenData.signature = this.signaturePad.toDataURL()
		},
		clearCanvas() {
			this.signaturePad.clear()
        },
		canEnableSignOnScreen() {
			if (this.signOnScreenData.company_name && this.signOnScreenData.signature && this.signOnScreenResponsiblePerson) {
				return true
			} else {
				return false
			}
		},
		enableSignOnScreen() {
			if (this.saving || !this.canEnableSignOnScreen()) {
				return
			}
            this.message = ''
			this.saving = true
			this.signOnScreenData.responsible_person = this.signOnScreenResponsiblePerson
    		this.apiCall({ destination: 'enable_signonscreen', data: this.signOnScreenData }).then(obj => {
                this.saving = false
                this.message = obj.message
				if (obj.status == 'success') {
					this.signOnScreenEnabled = true
				}
    		})
		},
		generateSignOnScreenPDF() {
			let htmlContent = this.$refs.sign_on_screen_content.innerHTML
			this.saving = true
    		this.apiCall({ destination: 'generate_signonscreen_pdf', data: { html_text: htmlContent } }).then(obj => {
                this.saving = false
    			if (obj.status == 'success') {
					window.open(obj.pdf_url)
    			}
    		})
		},
		getEnableTransactionRecords() {
    		this.apiCall({ destination: 'get_item_preference', data: { preference_code: 'FIREARMS_TRANSACTION_INFO' } }).then(obj => {
				this.firearmsTransactionInfo = obj.FIREARMS_TRANSACTION_INFO
    		})
		},
		enableTransactionRecords() {
			if (this.saving) { return }
			this.saving = true
			let newValue = this.firearmsTransactionInfo ? '' : 'required'
			this.message = ''
			this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'FIREARMS_TRANSACTION_INFO', value: newValue } }).then(obj => {
				this.saving = false
				this.message = obj.message
				if (obj.status == 'success') {
					this.firearmsTransactionInfo = newValue
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@media print {
    .list-view { grid-template-columns: 1fr; }
    .filters { display: none; }
}
</style>
